import classNames from 'classnames';
import { ReactNode } from 'react';
import styles from './GradientLayerLegend.module.scss';

// https://www.figma.com/design/6lD2rWP01sgcuqzuhG6EXK/Conditions-%2F-Overlays-2.0-Web-(Handoff)?node-id=93-29360

type Props = {
  gradientBackgroundStyle: string;
  ticks: [number, ReactNode][]; // [offset (0.0 - 1.0), text]
};

const GradientLayerLegend = ({ gradientBackgroundStyle, ticks }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.gradient} style={{ background: gradientBackgroundStyle }} />
      <div className={styles.ticks}>
        {ticks.map(([offset, text], index) => (
          <span
            key={index}
            className={classNames(styles.tick, { [styles.start]: offset === 0, [styles.end]: offset === 1 })}
            style={{ left: `${offset * 100}%` }}
          >
            {text}
          </span>
        ))}
      </div>
    </div>
  );
};

export default GradientLayerLegend;
